import { atomWithReset } from 'jotai/utils';
import {atom} from "jotai/index";
import type {Element, ElementContext} from "@/types/survey";
import { contextNavAtom } from '@/_atoms/navigation';
import { surveyElementsAtom } from '@/_atoms/survey';

/** The content of the error message to show. */
export const loginCodeEmailRequestErrorMessageAtom = atomWithReset<string | null>(null);

/** Whether a login code is currently being sent via email. */
export const isSendingLoginCodeAtom = atomWithReset<boolean>(false);

/**
 * Determines whether the first element on the next page is an email address verification field.
 *
 * This atom exists for backward compatibility with the legacy email verification system.
 * Once no respondents have those materials cached, this atom can be removed.
 */
export const hasEmailAddressVerificationFieldAtom = atom((get): boolean => {
    const nextElementContext: ElementContext | null = get(contextNavAtom).firstElementOnNextPageContext;
    if (!nextElementContext) return false;

    const surveyElements: Element[] = get(surveyElementsAtom);
    const nextElement: Element | null = surveyElements[nextElementContext.index] ?? null;
    if (!nextElement) return false;

    return 'category' in nextElement && nextElement.category === 'EAV';
  }
);